var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3722c0ede279f76edfa5766ae62d164f6947c353"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["app-20-next@plant-for-the-planet"]={id:"3722c0ede279f76edfa5766ae62d164f6947c353"};
      